// <span class="whitespace-nowrap" v -if= "$props.timeslot" >
//   <span v -if= "props.timeslot?.title" > {{ props.timeslot?.title }} | </span>
//     < date - view format = "eeeeee P" : date = "props.timeslot.start_date" />
//         & nbsp; (<date-view format = "p" : date = "props.timeslot.start_date" />
//   <template v -if= "props.timeslot.end_date" >& nbsp; -& nbsp; <date-view format = "p" : date = "props.timeslot.end_date" />
//     </template>)
// </span>

import { Tables } from "~~/types/supabase";

export default (timeslot: Tables<'event_timeslots'>) => {
  if (!timeslot) return '';
  const dateStr = timeslotToDateString(timeslot) ?? '';
  return timeslot?.title ? `${timeslot.title} | ${dateStr}` : dateStr;
}
